webpackJsonp([203152047843952],{

/***/ 1318:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"StripePaymentType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"Payment was processed via Stripe Terminal (card tap)","isDeprecated":false,"name":"CARD_PRESENT"},{"deprecationReason":null,"description":"Payment was processed via Stripe Interac (Interac debit)","isDeprecated":false,"name":"INTERAC_PRESENT"},{"deprecationReason":null,"description":"Payment type could not be determined","isDeprecated":false,"name":"UNKNOWN"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-stripe-payment-type-241c234eec6a55c140b4.js